import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=2f3fdc27&scoped=true&"
import script from "./RoleTable.vue?vue&type=script&lang=js&"
export * from "./RoleTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=2f3fdc27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3fdc27",
  null
  
)

export default component.exports